var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "noOrderListIcon",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2427 15.8296L12.2573 16.1627C12.0821 16.1912 11.9079 16.2065 11.7347 16.2065C10.9513 16.2065 10.1995 15.9101 9.61581 15.36C8.90374 14.6876 8.55534 13.7433 8.66129 12.7694L8.88133 10.7381C9.00154 9.62672 9.45893 8.59783 10.2036 7.76453L14.4247 3.15657C14.6043 2.96052 14.4651 2.64453 14.1993 2.64453H8.15601C4.93997 2.64453 2.7793 4.90707 2.7793 8.27389V16.3695C2.7793 19.7373 4.93997 21.9999 8.15601 21.9999H16.7477C19.9648 21.9999 22.1265 19.7373 22.1265 16.3695V9.67829C22.1265 9.39952 21.7838 9.2663 21.5955 9.47185L17.3131 14.1467C16.5287 15.0238 15.4316 15.6289 14.2427 15.8296Z",
    fill: "url(#paint0_linear_2059_37822)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9062 10.9575L10.7045 12.8207C10.6189 13.6061 11.3076 14.255 12.0869 14.1246L13.9022 13.82C14.6387 13.6957 15.3121 13.3259 15.8092 12.7697L21.7146 6.32439C22.4216 5.5624 22.3747 4.37255 21.6128 3.66761L20.3526 2.50018C19.5896 1.79523 18.3998 1.84108 17.6938 2.60205L11.7232 9.12073C11.2658 9.63314 10.9805 10.2749 10.9062 10.9575Z",
    fill: "url(#paint1_linear_2059_37822)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2059_37822",
    x1: 2.7793,
    y1: 2.64453,
    x2: 2.7793,
    y2: 21.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2059_37822",
    x1: 10.6973,
    y1: 2,
    x2: 10.6973,
    y2: 14.1414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.24c1ae55.svg";
export { ForwardRef as ReactComponent };